import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { colorThemeGenerator } from '@spotify-internal/encore-creator-web';
import { kleinBlue } from '@spotify-internal/encore-foundation';
import { Route } from 'react-router-dom';

const lightTheme = colorThemeGenerator({ primaryColor: kleinBlue });

const darkComponents = {
  app: 'dark',
  table: 'dark',
  tableRow: 'dark',
  buttonIcon: 'dark',
  loadingIndicator: 'dark',
  navBar: 'dark',
  navBarList: 'dark',
  navBarListItem: 'dark',
  dialogAlert: 'dark',
  dialogConfirmation: 'dark',
  formGroup: 'dark',
  formInput: 'dark',
  button: 'dark',
};

const Wrapper = styled.div`
  --primaryColor: ${({ theme }) => theme.colors.primaryColor};
`;

/**
  '#7F80FA' is a lighter / accessible version of Klein Blue meant for dark backgrounds.
  Follow along at https://ghe.spotify.net/encore/foundation/issues/29 for discussions on accessible dark themed color tokens.
  */

const darkTheme = {
  ...darkComponents,
  ...colorThemeGenerator({ primaryColor: '#7F80FA' }),
};

type Props = {
  darkThemePaths: string[];
  children?: JSX.Element;
};

export function PageThemeProvider({ darkThemePaths, children }: Props) {
  return (
    <Route path={darkThemePaths}>
      {({ match }) => (
        <ThemeProvider theme={match ? darkTheme : lightTheme}>
          <Wrapper>{children}</Wrapper>
        </ThemeProvider>
      )}
    </Route>
  );
}
